import { ApexOptions } from 'apexcharts';
import React from 'react';
import ReactApexChart from 'react-apexcharts';


const DonutChart = (props: {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries | undefined;
  options: ApexOptions;
}) => {
  return (
    <div id="chart">
      <ReactApexChart
        options={props.options}
        series={props.series}
        type="donut"
      />
    </div>
  );
};

export default DonutChart;
